/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmSearchRequest = {
    filterBy?: EvmSearchRequest.filterBy;
    term: string;
};

export namespace EvmSearchRequest {

    export enum filterBy {
        ALL = 'ALL',
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        TOKEN = 'TOKEN',
        MODULE = 'MODULE',
        COIN = 'COIN',
        FUNGIBLE_ASSET = 'FUNGIBLE_ASSET',
        COLLECTION = 'COLLECTION',
        OBJECT = 'OBJECT',
        BATCH_TRX = 'BATCH_TRX',
    }


}

